
    <label for="scheduleReportBtnLabel" id="scheduleReportBtnLabel">
        <p-button id="scheduleReportBtn" type="button" class="commentBtn" [ngClass]="'button btn-xs non-active-symbol'"
            (onClick)="onScheduleReportBtn()">
            Schedule Report
        </p-button>
    </label>

<p-dialog id="filter-dialog" [modal]="true" [header]="filterHeader" [style]="{ width: '1000px' }"
    styleClass="quick-view-grid-row filterbox filter-dialog-box" [(visible)]="isOpenDialog"
    maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times" [closable]="true" appendTo="body"
    (onHide)="closeFilterDialog()" (visibleChange)="closeFilterDialog()">
    <div class="ui-g">
         @if(isLoadingRecords) {
        <div class="example-loading-shade"></div>
        }
        <div class="card flex justify-center gap-4">
            <div class="flex items-center">
                <div class="ui-g-12">
                    <div class="ui-grid-col-5 quick-view-grid-row-hg labelName">
                        <label for="ui_Field_Name">Run Frequency <sup>*</sup></label>
                    </div>
                    <div class="ui-grid-col-7 quick-view-grid-row-hg">
                        <div class="card flex justify-center">
                            <p-selectbutton [options]="frequencyDropdownvalue"  
                            (onChange)="onChangeFrequency()"
                            [(ngModel)]="selectedFrequency" optionLabel="label" optionValue="value" aria-labelledby="basic" />
                        </div>

                    </div>
                </div>
                <div class="ui-g-12">
                    <div class="ui-g-6 nopadding">
                        <div class="ui-grid-col-8 quick-view-grid-row-hg nopadding">
                            <label for="ui_Field_Name">Week Of Month <sup>*</sup></label>
                        </div>
                        <div class="ui-grid-col-4 quick-view-grid-row-hg nopadding">
                            <p-select id="filterDrpbySingleSelect" name="filterDrpbySingleSelect"
                                [options]="weekOfMonthDropdownvalue" [(ngModel)]="selectedWeekOfMonth"
                                [disabled]="selectedFrequency=='' || selectedFrequency=='W'"
                                placeholder="Please Select" appendTo="body" required="true"
                                styleClass="filter-dropdown">
                                <ng-template let-filterCols pTemplate="item">
                                    <div class="ui-helper-clearfix singleSelectDropdownOptions">
                                        <div [id]="filterCols.label" [matTooltip]="filterCols?.label"
                                            [matTooltipShowDelay]="1000" matTooltipPosition="after">
                                            {{filterCols?.label}}</div>
                                    </div>
                                </ng-template>
                            </p-select>

                        </div>
                    </div>
                    <div class="ui-g-6 nopadding">
                        <div class="ui-grid-col-8 quick-view-grid-row-hg nopadding">
                            <label for="ui_Field_Name" class="label-day-fo-week">Day Of Week <sup>*</sup> </label>
                        </div>
                        <div class="ui-grid-col-4 quick-view-grid-row-hg nopadding">
                            <p-select id="filterDrpbySingleSelect" name="filterDrpbySingleSelect"
                                [options]="dayOfWeekDropdownvalue" [(ngModel)]="selectedDayOfWeek"
                                placeholder="Please Select" appendTo="body" required="true" styleClass="filter-dropdown"
                                [disabled]="selectedFrequency==''">
                                <ng-template let-filterCols pTemplate="item">
                                    <div class="ui-helper-clearfix singleSelectDropdownOptions">
                                        <div [id]="filterCols.label" [matTooltip]="filterCols?.label"
                                            [matTooltipShowDelay]="1000" matTooltipPosition="after">
                                            {{filterCols?.label}}</div>
                                    </div>
                                </ng-template>
                            </p-select>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card flex justify-center gap-4">
                            <label for="ui_Field_Name">Custom Sample Names <sup>*</sup> </label>
            <div class="flex items-center ">
                    @for (sample of sampleListData; track sample.label; let idx = $index){
                    <label [for]="sample.label" class="sampleLabelName">
                     <p-checkbox [inputId]="sample.label" [name]="sample.label" [value]="sample.label"
                        [(ngModel)]="selectedSamples" />
                     {{sample.label}} 
                    </label>
                    }
            </div>
        </div>

        <div class="card flex justify-center gap-4" >
            <label for="ui_Field_Name"> Last 5 Runs: </label>
            <p-table 
            showCurrentPageReport="true"
            [value]="dataset1" 
            [columns]="cols" 
            [resizableColumns]="true" 
            columnResizeMode="expand"
            [totalRecords]="5" 
            appendTo="body" 
            scrollHeight="60vh"
            class="p-datatable"
            sortMode="multiple"
            #dt>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length">
                  {{tbldatamsg}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                 
                    @for (col of columns; track col;){
                <th id="columns" pResizableColumn [pSortableColumn]="col.field" style="text-align: left;"
                  [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                  {{col.header}}
                </th>}
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
              <tr [ngClass]="'ui-widget-NoUpdated-row'">
                  @for (col of columns; track col;){  
                <td class="ui-resizable-column"
                  [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                  <!-- set String -->
                   @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'){
                  <span>
                        {{row[col.field]}}
                  </span>}
                       <!-- set int  -->
                        @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                       <span style="float:right;">
                        @if(row[col.field]){
                       <span>{{row[col.field] * 1 }}</span>}
                     </span>}
        
                </td>}
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="card flex justify-center gap-4" >
            <div class="ui-g-12">
                <div class="ui-g-6 nopadding">
                    <div class="ui-grid-col-12 quick-view-grid-row-hg nopadding">
                        <label for="ui_Field_Name">Updated User : </label> {{updatedUser}}
                    </div>
                   
                </div>
                <div class="ui-g-6 nopadding">
                    <div class="ui-grid-col-12 quick-view-grid-row-hg nopadding">
                        <label for="ui_Field_Name" class="label-day-fo-week">Updated Date :  </label> {{updatedDate}}
                    </div>
                </div>
            </div>
     
        </div>
        
    </div>
    <ng-template #footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix" style="margin-top:1px !important;">
            <p-button id="closeScheduleDialog" class="applyButton close-footer-button floatRight" icon="fa fa-close"
                (onClick)="cancel()" label="Cancel">
            </p-button>
            <p-button id="saveScheduleDialog" class="applyButton floatRight" [loading]="isSaving"
                [disabled]="checkDisabledSave() || selectedFrequency ==''" icon="fa fa-check" (onClick)="save()"
                label="Save">
            </p-button>
        </div>
    </ng-template>
</p-dialog>